import PropTypes from 'prop-types';
import cx from 'classnames';
import { AlloyButton, Popup } from 'cat-ecommerce-alloy';
import { availability as availabilityPropTypes } from '../../../Availability/Availability.proptypes';
import ContactDealerPopup from '../../../ContactDealerPopup';

const ProductOverviewAvailability = ({ availability = [], className }) => {
  const { availabilityMessage, showContactDealerPopUp } = availability[0] ?? {};
  const textClass = 'fw-bold u-fs--14 mb-0';
  const availabilityContent = showContactDealerPopUp ? (
    <Popup
      contents={<ContactDealerPopup />}
      initiator={
        <AlloyButton
          buttonType="link"
          className={cx('p-0', textClass, className)}
        >
          {availabilityMessage}
        </AlloyButton>
      }
    />
  ) : (
    <p className={cx(textClass, className)}>{availabilityMessage}</p>
  );

  return availabilityMessage ? availabilityContent : null;
};

ProductOverviewAvailability.propTypes = {
  availability: availabilityPropTypes,
  className: PropTypes.string
};

export default ProductOverviewAvailability;
